import React, { Component } from 'react'
// import { CrfContext } from "../../CrfContext"
import axios from 'axios'
import { Link } from 'react-router-dom'
import { getData } from './actions'

export class DraftView extends Component {
  state = {
    initializeValue: true,

    showPage1: true,
    showPage2: false,

    showPage1Err: false,
    showPage2Err: false,

    vendorLists: [],
    projectLists: [],
    itemNoLists: [],

    removal: false,
    target: null
  }

  componentDidMount () {
    let cocExpenses = []
    console.log(this.props.requestType)

    // =============INITIALIZE INPUT VALUE =========================================================================================================
    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/checkRequestForm/${this.props.requestId}`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        const data = response.data.data
        // console.log(data.projectClass)
        this.setState({
          // crfNo: data.crfNo,
          initializeValue: true,

          requestType: data.requestType,
          requestor: data.requestor.firstName + ' ' + data.requestor.lastName,
          subProject: data.subProject,
          projectClass: data.projectClass,
          dueDate: data.dueDate,
          creationDate: data.creationDate,
          _id: data._idDate,
          rejectionMessage: data.rejectionMessage,

          vendor: data.vendor
        })

        // ===============================================================

        axios({
          method: 'GET',
          url: `${process.env.REACT_APP_API_KEY}/api/projects/${data.projectName}`,
          headers: {
            'Api-Key':
              '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
            Authorization: `Bearer ${localStorage.token}`
          }
        })
          .then(response => {
            console.log(response)
            this.setState({
              projectCode: response.data.data.projectCode
            })
            console.log(this.state.projectCode)

            // GET THE GLNAME
            axios({
              method: 'GET',
              url: `${process.env.REACT_APP_API_KEY}/api/glAccountTypes/${response.data.data.projectCode}`,
              headers: {
                'Api-Key':
                  '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                Authorization: `Bearer ${localStorage.token}`
              }
            })
              .then(response => {
                console.log(response)
                this.setState({
                  accountTypes: response.data.data
                })
                console.log(this.state.accountTypes)
              })
              .catch(error => {
                console.log(error.response)
              })
          })
          .catch(error => {
            console.log(error.response)
          })
        // ====================================================================

        for (let index = 0; index < data.projectClass.length; index++) {
          // THIS WILL PUT AN INITIAL VALUE TO PROJECT CLASS INPUTS
          console.log(data.projectClass[index].wTaxType)
          // document.getElementsByName('glCategory')[index].value = `${data.projectClass[index].glCategory}`
          if (data.projectClass[index].glCategory) {
            // console.log(document.getElementsByName('glCategoryInitialValue')[index])
            document.getElementsByName('glCategoryInitialValue')[
              index
            ].value = `${data.projectClass[index].glCategory}`
            document.getElementsByName('glCategoryInitialValue')[
              index
            ].innerText = `${data.projectClass[index].glCategory}`
          }

          // document.getElementsByName('wTaxType')[index].value = `${data.projectClass[index].wTaxType}`
          // document.getElementsByName('vatType')[index].value = `${data.projectClass[index].vatType}`
          // document.getElementsByName('grossPricePerItem')[index].value = data.projectClass[index].grossPricePerItem
          // document.getElementsByName('description1')[index].value = `${data.projectClass[index].description1}`
          // document.getElementsByName('description2')[index].value = `${data.projectClass[index].description2}`
          axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/accountName/${data.projectClass[index].glAccount}`,
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              console.log(response.data.data[index].accountName)
              data.projectClass[index].accountName =
                response.data.data[index].accountName
              console.log(data.projectClass[index])
              for (let i = 0; i < data.projectClass.length; i++) {
                axios({
                  method: 'GET',
                  url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/accountName/${data.projectClass[i].glAccount}`,
                  headers: {
                    'Api-Key':
                      '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                    Authorization: `Bearer ${localStorage.token}`
                  }
                })
                  .then(response => {
                    console.log(response)
                  })
                  .catch(error => {
                    console.log(error.response)
                  })
                document.getElementsByClassName('glNameClass')[i].value =
                  data.projectClass[i].glAccount +
                  ' ' +
                  data.projectClass[i].accountName
              }
            })
            .catch(error => {
              console.log(error.response)
            })
        }

        if (data.vendor) {
          this.setState({
            vendor: data.vendor
          })
          document.getElementById('vendorInput').value = data.vendor
        }

        if (response.data.data.particulars) {
          this.setState({
            particulars: response.data.data.particulars
          })
          document.getElementById('particularsInput').value = data.particulars
        }

        if (data.department) {
          this.setState({
            requestingDepartment: data.department
          })
          document.getElementById('departmentInput').value = data.department
          // console.log(data.department)
        }

        if (data.projectName) {
          this.setState({
            project: data.projectName
          })

          document.getElementById('projectInput').value = data.projectName
        }

        if (data.subProject) {
          this.setState({
            subProject: data.projectName
          })
          document.getElementById('subProject').value = data.subProject
        }
        console.log(this.state)

        // console.log(this.state.projectClass)
        let accountType = []
        let accountName = []
        let quantity = []
        let subtotalGrossPrice = []
        let subtotalUnitPrice = []
        for (let i = 0; i < this.state.projectClass.length; i++) {
          accountType.push(this.state.projectClass[i].glAccount.accountType)
          accountName.push(this.state.projectClass[i].glAccount.accountName)
          quantity.push(this.state.projectClass[i].quantity)
          subtotalGrossPrice.push(
            this.state.projectClass[i].grossPrice *
              this.state.projectClass[i].quantity
          )
          subtotalUnitPrice.push(this.state.projectClass[i].unitPrice)
        }

        let totalGrossPrice = 0
        for (let subt = 0; subt < this.state.projectClass.length; subt++) {
          totalGrossPrice = totalGrossPrice + subtotalGrossPrice[subt]
        }

        let totalUnitPrice = 0
        for (let subt = 0; subt < this.state.projectClass.length; subt++) {
          totalUnitPrice = totalUnitPrice + subtotalUnitPrice[subt]
        }

        // console.log(totalGrossPrice)

        this.setState({
          accountType: accountType,
          accountName: accountName,
          totalGrossPrice: totalGrossPrice,
          quantity: quantity,
          totalUnitPrice: totalUnitPrice
        })
      })
      .catch(error => {
        // console.log(error.response)
      })

    // ============================================================

    axios({
      method: 'GET',
      url: `${process.env.REACT_APP_API_KEY}/api/itemNo`,
      headers: {
        'Api-Key':
          '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
        Authorization: `Bearer ${localStorage.token}`
      }
    })
      .then(response => {
        console.log(response)
        this.setState({
          itemNoLists: response.data.data
        })
      })
      .catch(error => {
        console.log(error.response)
      })

    if (document.getElementById('poInput')) {
      document.getElementById('poInput').value = this.props.poNumber
    }

    if (this.props.requestingDepartment !== '') {
      document.getElementById(
        'departmentInitialValue'
      ).innerText = this.props.requestingDepartment
    }
    document.getElementById('vendorInput').value = this.props.vendor
    document.getElementById('particularsInput').value = this.props.particulars
    document.getElementById('projectInput').value = this.props.project
    document.getElementById('subProjectInput').value = this.props.subProject

    for (let i = 0; i < this.props.projectClass.length; i++) {
      if (this.props.projectClass[i].glCategory !== '') {
        document.getElementsByName('glCategoryInitialValue')[
          i
        ].value = `${this.props.projectClass[i].glCategory}`
        document.getElementsByName('glCategoryInitialValue')[
          i
        ].innerText = `${this.props.projectClass[i].glCategory}`
        if (this.props.projectClass[i].projectClass) {
          document.getElementsByName('projectClass')[
            i
          ].value = `${this.props.projectClass[i].projectClass}`
        }
      } else {
        document.getElementsByName('glCategoryInitialValue')[
          i
        ].value = `${this.props.projectClass[i].glCategory}`
        document.getElementsByName('glCategoryInitialValue')[i].innerText =
          'Please Choose...'
      }

      // ========= INITIAL LIST OF GL ACCOUNT NAME/CODE ==============================================================
      if (this.props.projectClass[i].glCategory === 'COC Expenses') {
        document
          .getElementsByName('glCategory')
          [i].nextElementSibling.nextElementSibling.setAttribute(
            'list',
            'cocExpenses'
          )
        // console.log(this.props.cocExpenses[i].substring(0,10))
        console.log(
          this.props.cocExpenses.filter(
            coc => coc.substring(0, 10) === this.props.projectClass[i].glAccount
          )
        )

        document.getElementsByName('glAccount')[
          i
        ].value = this.props.cocExpenses.filter(
          coc => coc.substring(0, 10) === this.props.projectClass[i].glAccount
        )
      }

      if (this.props.projectClass[i].glCategory === 'Advances') {
        document
          .getElementsByName('glCategory')
          [i].nextElementSibling.nextElementSibling.setAttribute(
            'list',
            'advances'
          )

        document.getElementsByName('glAccount')[
          i
        ].value = this.props.advances.filter(
          adv => adv.substring(0, 10) === this.props.projectClass[i].glAccount
        )

        // if (!this.props.isProject) {
        //   document.getElementsByClassName('glNameClassProjectClass')[
        //     i
        //   ].style.display = 'block'
        //   document.getElementsByClassName('label2ProjectClass')[
        //     i
        //   ].style.display = 'block'
        // }
      }

      if (this.props.projectClass[i].glCategory === 'Admin Expenses') {
        document
          .getElementsByName('glCategory')
          [i].nextElementSibling.nextElementSibling.setAttribute(
            'list',
            'adminExpenses'
          )

        document.getElementsByName('glAccount')[
          i
        ].value = this.props.adminExpenses.filter(
          adx => adx.substring(0, 10) === this.props.projectClass[i].glAccount
        )
      }

      if (this.props.projectClass[i].glCategory === 'PPE Accounts') {
        document
          .getElementsByName('glCategory')
          [i].nextElementSibling.nextElementSibling.setAttribute(
            'list',
            'ppeAccounts'
          )

        document.getElementsByName('glAccount')[
          i
        ].value = this.props.ppeAccounts.filter(
          ppe => ppe.substring(0, 10) === this.props.projectClass[i].glAccount
        )
      }

      if (this.props.requestType === 'PO Item') {
        if (this.props.projectClass[i].itemCode) {
          document.getElementsByName('itemCode')[
            i
          ].value = this.props.projectClass[i].itemCode
          document.getElementsByName('quantity')[
            i
          ].value = this.props.projectClass[i].quantity
        } else {
          document.getElementsByName('itemCode')[i].value = ''
        }
      }

      // document.getElementsByName('grossPricePerItem')[i].value = this.props.projectClass[i].grossPricePerItem
      // document.getElementsByName('description1')[i].value = this.props.projectClass[i].description1
      // document.getElementsByName('description2')[i].value = this.props.projectClass[i].description2
      console.log(this.props.projectClass[i])
      // console.log(this.props.wTaxRates.filter(wtx => wtx.wTaxCode === this.props.projectClass[i].wTaxType)[0].wTaxDisplayName
      // + " " + this.props.wTaxRates.filter(wtx => wtx.wTaxCode === this.props.projectClass[i].wTaxType)[0].wTaxCode)

      // document.getElementsByClassName('vatTypeInitialValue')[i].innerText = this.props.projectClass[i].vatType

      if (this.props.projectClass[i].vatType !== '') {
        document.getElementsByClassName('vatTypeInitialValue')[
          i
        ].innerText = this.props.projectClass[i].vatType
      } else {
        // document.getElementsByClassName('vatTypeInitialValue')[i].innerText = "Please Choose"
      }
      // if(!this.props.wTaxRates === []){
      // if(this.props.projectClass[i].wTaxType !== ""){
      //   if(this.props.projectClass[i].wTaxType === "X1"){
      //     document.getElementsByClassName('wTaxInitialValue')[i].innerText = "None  (X1)"
      //   }else{
      //     document.getElementsByClassName('wTaxInitialValue')[i].innerText = this.props.wTaxRates.filter(wtx => wtx.wTaxCode === this.props.projectClass[i].wTaxType)[0].wTaxDisplayName
      //     + " " + this.props.wTaxRates.filter(wtx => wtx.wTaxCode === this.props.projectClass[i].wTaxType)[0].wTaxCode
      //   }
      // }else{
      //   document.getElementsByClassName('wTaxInitialValue')[i].innerText = "Please Choose..."
      //   document.getElementsByClassName('wTaxInitialValue')[i].setAttribute("selected", "")
      //   // document.getElementsByClassName('wTaxInitialValue')[i].setAttribute("hidden", "")
      //   // document.getElementsByClassName('wTaxInitialValue')[i].setAttribute("disabled", "")
      // }

      // }
    }
  }

  handleShowPage2 = async e => {
    e.preventDefault()
    if (this.props.dueDate === '') {
      alert('Due date is required')
      return
    }
    if (!this.validateDueDate(this.props.dueDate)) {
      alert('Due date must be greater than or equal to current date')
      return
    }
    const data = await this.props.handleSubmitDraft(e, 'fromFirstPage')
    if (data) return
    //    if(this.props.vendorErr + this.props.particularsErr + this.props.projectErr
    //      + this.props.fileErr === 0){
    document.getElementById('page1').style.display = 'none'
    document.getElementById('nextButton').style.display = 'none'
    document.getElementById('page2').style.display = 'block'
    document.getElementById('formPrevBtn').style.display = 'block'
    document.getElementById('totalComputation').style.display = 'flex'
    document.getElementById('submitButtonDiv').style.display = 'block'
    //  }else{
    //   this.setState({showPage1Err: true})
    //  }
    // THIS WILL COMPUTE IN TOTAL GROSS PRICE AND TOTAL NET PRICE IN PAGE 2 OF FORM
    // console.log(document.getElementsByClassName("subTotalGrossPrice"))
    // let subTotalGrossPrice = document.getElementsByClassName("subTotalGrossPrice")
    // let subTotalNetPrice = document.getElementsByClassName("subTotalNetPrice")
    // let requestingGrossPrice = document.getElementById("requestingGrossPrice")
    // let requestingAmount = document.getElementById("requestingAmount")
    // let requestingGrossPriceValue = 0
    // let requestingAmountValue = 0
    // for (let i = 0; i < this.props.projectClass.length; i++) {
    //   subTotalGrossPrice[i].innerText = (this.props.projectClass[i].grossPricePerItem *
    //       this.props.projectClass[i].quantity).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    //   requestingGrossPriceValue = requestingGrossPriceValue + (this.props.projectClass[i].grossPricePerItem *
    //   this.props.projectClass[i].quantity)

    //   subTotalNetPrice[i].innerText = (this.props.projectClass[i].netPricePerItem *
    //       this.props.projectClass[i].quantity).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    //   requestingAmountValue = requestingAmountValue + (this.props.projectClass[i].netPricePerItem *
    //     this.props.projectClass[i].quantity)

    // }

    // requestingGrossPrice.innerText = (requestingGrossPriceValue).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    // requestingAmount.innerText = (requestingAmountValue).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
  }

  handleShowPage1 = e => {
    e.preventDefault()
    document.getElementById('page1').style.display = 'block'
    document.getElementById('nextButton').style.display = 'block'
    document.getElementById('page2').style.display = 'none'
    document.getElementById('formPrevBtn').style.display = 'none'
    document.getElementById('totalComputation').style.display = 'none'
    document.getElementById('submitButtonDiv').style.display = 'none'
  }

  handleRemoveProjectClass = e => {
    console.log(e.target)
    console.log(e.target.name)
    this.props.projectClass.splice(parseInt(e.target.id), 1)
    this.setState({
      target: parseInt(e.target.name),
      removal: true
    })
  }
  currentDate = () => {
    const dateArray = Date().split(' ')
    let month = ''
    const day = dateArray[2]
    const year = dateArray[3]
    switch (dateArray[1]) {
      case 'Feb':
        month = '02'
        break
      case 'Mar':
        month = '03'
        break
      case 'Apr':
        month = '04'
        break
      case 'May':
        month = '05'
        break
      case 'Jun':
        month = '06'
        break
      case 'Jul':
        month = '07'
        break
      case 'Aug':
        month = '08'
        break
      case 'Sep':
        month = '09'
        break
      case 'Oct':
        month = '10'
        break
      case 'Nov':
        month = '11'
        break
      case 'Dec':
        month = '12'
        break
      default:
        month = '01'
    }
    return `${year}-${month}-${day}`
  }

  validateDueDate = date => {
    const currentDate = new Date()
    const givenDate = new Date(date.substring(0, 10))
    if (givenDate < currentDate) {
      if (this.currentDate() === date.substring(0, 10)) {
        return true
      }
      return false
    } else {
      return true
    }
  }
  render () {
    console.log(this.props.projectClass)

    console.log(document.getElementById('vendorInput'))
    // console.log(this.props.particularsError)
    let projectClassList = []
    for (let key in this.props.projectClass) {
      projectClassList.push(key)
    }

    let particularsEmptyChecker = ''
    if (this.props.particularsError === true) {
      particularsEmptyChecker = (
        <>
          {this.props.particulars === '' ? (
            <small style={errorChecker}>This field can't be empty</small>
          ) : null}
        </>
      )
    }

    let vendorEmptyChecker = ''
    if (this.props.vendorError === true) {
      vendorEmptyChecker = (
        <>
          {this.props.vendor === '' ? (
            <small style={errorChecker}>This field can't be empty</small>
          ) : null}
        </>
      )
    }

    let projectEmptyChecker = ''
    if (this.props.projectError === true) {
      projectEmptyChecker = (
        <>
          {this.props.project === '' ? (
            <small style={errorChecker}>This field can't be empty</small>
          ) : null}
        </>
      )
    }

    let fileEmptyChecker = ''
    if (this.props.supportingDocumentError === true) {
      projectEmptyChecker = (
        <>
          {this.props.file === null ? (
            <small style={errorChecker}>Please upload A file</small>
          ) : null}
        </>
      )
    }

    if (this.state.removal === true) {
      projectClassList.splice(this.state.target, 1)
      console.log('test')
      projectClassList = this.props.projectClass
      // this.props.projectClass = projectClassList
      // this.props.projectClass.splice(this.state.target, 1)
    }

    const filterProjectClass = arg => {
      if (arg === 'Advances' || arg === 'COC Expenses') {
        const projectClassArray = []
        this.props[
          arg === 'Advances'
            ? 'projectClassAdvances'
            : 'projectClassCocExpenses'
        ].filter(data => {
          const isExist = projectClassArray.some(
            data2 => data2.centerName === data.centerName
          )
          if (!isExist) {
            projectClassArray.push(data)
          }
        })
        return projectClassArray.map(data => <option value={data.centerName} />)
      }
    }
    return (
      <>
        <div className='formContent'>
          <div className='formNavigationBtn'>
            <div className='formNavContent'>
              <div id='formPrevBtn' className='formNav1'>
                <button type='button' onClick={this.handleShowPage1}>
                  <i class='fas fa-arrow-alt-circle-left'></i>
                  {/* back */}
                </button>
              </div>
            </div>
          </div>

          {/* PAGE 1 */}

          <form onSubmit={this.props.handleSubmitDraft}>
            <div className='saveAndCancelButton'>
              <div className='saveAndCancelButtonContent'>
                <button
                  style={styleBtn}
                  id='draftSaveBtn'
                  type='button'
                  onClick={this.props.handleDraftNonPo}
                >
                  SAVE
                </button>
              </div>
            </div>
            <div className='page1' id='page1'>
              {/* due date */}
              <p className='label1'>
                Due date
                <span id='vendorEmptyError' className='errorChecker'>
                  *
                </span>
              </p>
              <input
                type='date'
                className='input1NonPo'
                name='dueDate'
                id='dueDate'
                min={this.currentDate()}
                value={
                  this.props.dueDate
                    ? this.props.dueDate.substring(0, 10)
                    : this.props.dueDate
                }
                onBlur={e => this.props.changed(e, 0, 'dueDate')}
                onChange={e => this.props.changed(e, 0, 'dueDate')}
                onKeyDown={e => {
                  e.preventDefault()
                }}
                placeholder='Required'
                autoComplete='off'
              />
              {/* PO NUMBER */}
              {this.props.requestType === 'PO Item' ? (
                <>
                  <p className='label1'>
                    PO NUMBER
                    <span id='vendorEmptyError' className='errorChecker'>
                      *
                    </span>
                  </p>
                  <input
                    type='text'
                    className='input1NonPo'
                    name='poNumber'
                    id='poInput'
                    value={this.props.poNumber}
                    onChange={e => this.props.changed(e, 0, 'poNumber')}
                    placeholder='Required'
                    autoComplete='off'
                  />
                </>
              ) : null}
              {/* END OF PO NUMBER */}

              {/* VENDOR INPUT*/}
              <p className='label1'>
                Vendor/Payee:
                <span id='vendorEmptyError' className='errorChecker'>
                  *
                </span>
              </p>
              <input
                type='text'
                className='input1NonPo'
                list='vendorListOptions'
                name='vendor'
                id='vendorInput'
                value={this.props.vendor}
                onChange={this.props.handleChangeRequestField}
                placeholder='Required'
              />

              <datalist id='vendorListOptions'>
                {this.props.vendorLists.map(data => (
                  <option className='vendorListData' value={data} />
                ))}
              </datalist>

              <div>
                <small style={errorChecker}></small>
                <small></small>
              </div>
              {vendorEmptyChecker}
              {/* END OF VENDOR INPUT */}

              {/* REQUESTING DEPARTMENT INPUT*/}
              <p className='label1'>
                Requesting Department:
                <span id='particularsEmptyError' className='errorChecker'>
                  *
                </span>
              </p>
              <select
                type='text'
                className='input1NonPoNew'
                id='departmentInput'
                name='requestingDepartment'
                value={this.props.requestingDepartment}
                onChange={this.props.handleChangeRequestField}
                autoComplete='off'
                placeholder='Required'
              >
                <option
                  id='departmentInitialValue'
                  value=''
                  disabled
                  selected
                  hidden
                >
                  Please Choose...
                </option>
                {this.props.userDeptList
                  .filter(list => list.isApproved === true)
                  .map(depts => (
                    <option value={depts.centerName}>{depts.centerName}</option>
                  ))}
              </select>
              {/* END OF REQUESTING DEPARTMENT INPUT */}

              {/* PARTICULARS INPUT*/}
              <p className='label1'>
                Particulars:
                <span id='particularsEmptyError' className='errorChecker'>
                  *
                </span>
              </p>
              <input
                type='text'
                className='input1NonPo'
                id='particularsInput'
                name='particulars'
                value={this.props.particulars}
                onChange={this.props.handleChangeRequestField}
                autoComplete='off'
                placeholder='Required'
              />
              {particularsEmptyChecker}
              {/* END OF PARTICULARS INPUT */}
              <input
                id='departmentInput'
                type='hidden'
                value={this.props.userDepartment}
              />

              {/* PROJECT INPUT*/}
              <p className='label1'>
                Project:
                <span id='projectEmptyError' className='errorChecker'>
                  *
                </span>
              </p>
              <input
                type='text'
                className='input1NonPo'
                list='projectDataLists'
                id='projectInput'
                name='project'
                value={this.props.project}
                onChange={this.props.handleChangeRequestField}
                placeholder='Required'
                autoComplete='Off'
              />
              <datalist id='projectDataLists'>
                {this.props.projectLists.map(data => (
                  <option value={data} />
                ))}
              </datalist>

              <div>
                <small style={errorChecker}></small>
                <small></small>
              </div>

              {projectEmptyChecker}
              {/* END OF PROJECT INPUT */}

              {/* SUBPROJECT INPUT*/}
              <p className='label1'>
                Sub Project:
                <span id='subProjectEmptyError' className='errorChecker'></span>
              </p>

              <input
                type='text'
                className='input1NonPo'
                id='subProjectInput'
                name='subProject'
                value={this.props.subProject}
                onChange={this.props.handleChangeRequestField}
                placeholder='Optional'
                autoComplete='off'
              />

              {/* END OF SUBPROJECT INPUT */}

              {/* SUPPORTING DOCUMENTS INPUT*/}

              <p className='label1'>
                Change Supporting Documents:
                <span id='documentEmptyError' className='errorChecker'></span>
              </p>
              <div className='fileInputContainer'>
                <div className='uploadedFile'>
                  {fileEmptyChecker}
                  {this.props.file !== null ? (
                    <>
                      <h1 className='fileIcon'>
                        <i class='far fa-file-pdf'></i>
                      </h1>
                      <span>
                        {this.props.file === undefined
                          ? this.props.fileText
                            ? this.props.fileText
                            : 'Please upload a file...'
                          : this.props.file.name}
                      </span>
                    </>
                  ) : this.props.fileText ? (
                    <>
                      <h1 className='fileIcon'>
                        <i class='far fa-file-pdf'></i>
                      </h1>
                      <span>{this.props.fileText}</span>
                    </>
                  ) : null}
                </div>

                <label htmlFor='documentsInput' className='fileLabel'>
                  {this.props.file ? 'Change File' : 'Change File'}
                </label>
                <input
                  style={displayNone}
                  type='file'
                  id='documentsInput'
                  name='file'
                  accept='.pdf'
                  onChange={this.props.handleChangeRequestField}
                />
              </div>
              {this.props.fileText ? (
                <div className='currentAttachPdfContainer'>
                  <button
                    style={currentAttachPdf}
                    className='currentAttachPdf'
                    type='button'
                    onClick={this.props.handleDownloadPdf}
                  >
                    <i class='fas fa-file-pdf'></i> Current File Attached
                  </button>
                </div>
              ) : (
                <span></span>
              )}

              {/* END OF SUPPORTING DOCUMENTS INPUT */}
            </div>
            {/* END OF PAGE 1 */}
            {/* PAGE 2 */}
            <div className='page2' id='page2'>
              {/* ===================================================================================================================== */}

              {this.props.projectClass.map((data, index) => (
                <div
                  className='projectClassContainer'
                  key={'projectClassContainer' + index}
                >
                  <div className='closeButtonContainer'>
                    <h3 style={{ float: 'left' }}>{parseInt(index) + 1}</h3>
                    {index === 0 ? (
                      <span></span>
                    ) : (
                      <button
                        type='button'
                        className='removeProjClassBtn'
                        onClick={e =>
                          this.props.handleRemoveProjectClass(e, index)
                        }
                        name={index}
                      >
                        &times;
                      </button>
                    )}
                  </div>
                  {/* GL CATEGORY INPUT */}
                  <p className='label2'>
                    GL Category
                    <span
                      style={errorChecker}
                      className='projectClassEmptyError'
                    >
                      *
                    </span>
                  </p>
                  <select
                    className='glCategoryClass'
                    name='glCategory'
                    id={index}
                    value={data.glCategory}
                    onChange={event =>
                      this.props.changed(event, index, 'glCategory')
                    }
                  >
                    <option
                      value=''
                      name='glCategoryInitialValue'
                      disabled
                      selected
                      hidden
                    >
                      Please Choose...
                    </option>
                    {this.props.accountTypes.map(data => (
                      <option value={data}>{data}</option>
                    ))}
                  </select>
                  {/*END OF GL CATEGORY INPUT */}
                  {/* GL CATEGORY NAME */}
                  <p
                    className='label2'
                    style={this.props.isProject ? { display: 'none' } : {}}
                  >
                    Account Code/Account Name
                    <span
                      style={errorChecker}
                      className='projectClassEmptyError'
                    >
                      *
                    </span>
                  </p>
                  <input
                    style={this.props.isProject ? { display: 'none' } : {}}
                    className='glNameClass'
                    type='text'
                    name='glAccount'
                    id={index}
                    list='accountName'
                    autoComplete='off'
                    placeholder='Required'
                    value={data.glAccount}
                    onChange={event =>
                      this.props.changed(event, index, 'glAccount')
                    }
                  />

                  {/* project class for project*/}
                  <p
                    className='projectClassLabel'
                    style={this.props.isProject ? {} : { display: 'none' }}
                  >
                    Project Class
                    <span
                      style={errorChecker}
                      className='projectClassEmptyError'
                    >
                      *
                    </span>
                  </p>
                  <input
                    style={this.props.isProject ? {} : { display: 'none' }}
                    disabled={data.glCategory === 'PPE Accounts' ? true : false}
                    className='projectClassName'
                    type='text'
                    name='projectClass'
                    id={index}
                    list={`projectClass${index}`}
                    autoComplete='off'
                    placeholder={
                      data.glCategory === 'PPE Accounts'
                        ? 'PPE Accounts not allowed'
                        : 'Required'
                    }
                    value={data.projectClass}
                    onChange={e => {
                      const obj = this.props[
                        data.glCategory === 'Advances'
                          ? 'projectClassAdvances'
                          : 'projectClassCocExpenses'
                      ].find(pClass => pClass.centerName === e.target.value)
                      this.props.handleChangeProjectClassValue(
                        e,
                        obj,
                        'customizeProjectClass'
                      )
                    }}
                  />
                  <datalist id={`projectClass${index}`}>
                    {data.glCategory === 'Advances'
                      ? filterProjectClass(data.glCategory)
                      : filterProjectClass(data.glCategory)}
                  </datalist>

                  {/*END OF GL Project class for project users*/}

                  {/*gl account for project users*/}
                  <p
                    className='label2'
                    style={this.props.isProject ? {} : { display: 'none' }}
                  >
                    Account Code/Account Name
                    <span
                      style={errorChecker}
                      className='projectClassEmptyError'
                    >
                      *
                    </span>
                  </p>
                  <select
                    style={this.props.isProject ? {} : { display: 'none' }}
                    disabled={data.glCategory === 'PPE Accounts' ? true : false}
                    className='glNameClass'
                    name='glAccount'
                    id={index}
                    value={data.glAccount}
                    onChange={event =>
                      this.props.changed(event, index, 'glAccount')
                    }
                  >
                    <option
                      className='glCategoryInitialValue'
                      value=''
                      selected
                      hidden
                    >
                      Please Choose...
                    </option>
                    {this.props[
                      data.glCategory === 'Advances'
                        ? 'projectClassAdvances'
                        : 'projectClassCocExpenses'
                    ]
                      .filter(
                        ({ centerName, centerCode }) =>
                          centerName === data.projectClass && centerCode !== ''
                      )
                      .map(data => (
                        <option
                          value={`${data.accountCode} ${data.accountName} ${data.centerCode}`}
                        >{`${data.accountCode} ${data.accountName} ${data.centerCode}`}</option>
                      ))}
                  </select>

                  {/* PROJECT CLASS */}
                  {/* <p
                    className='label2ProjectClass'
                    style={
                      data.glCategory === 'Advances'
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                  >
                    Project Class
                    <span
                      style={errorChecker}
                      className='projectClassEmptyError'
                    >
                      *
                    </span>
                  </p>
                  <input
                    className='glNameClassProjectClass'
                    style={
                      data.glCategory === 'Advances'
                        ? { display: 'block' }
                        : { display: 'none' }
                    }
                    type='text'
                    name='projectClass'
                    id={index}
                    list='advancesList'
                    autoComplete='off'
                    placeholder='Required'
                    value={data.projectClass}
                    onChange={event =>
                      this.props.changed(event, index, 'projectClass')
                    }
                  />
                  <datalist id='advancesList'>
                    {this.props.advancesProjectClass.map(data => (
                      <option value={data} />
                    ))}
                  </datalist> */}

                  {/* ITEM NUMBER AND QUANTITY */}
                  {this.props.requestType === 'PO Item' ? (
                    <div className='quantityAndItemNumber'>
                      <div className='inputContainer1'>
                        <p className='label3'>
                          Item No.:
                          <span
                            style={errorChecker}
                            className='projectClassEmptyError'
                          >
                            *
                          </span>
                        </p>
                        <input
                          className='input3'
                          type='text'
                          id={index}
                          name='itemCode'
                          list='itemNumberList'
                          placeholder='Required'
                          value={data.itemCode}
                          onChange={event =>
                            this.props.changed(event, index, 'itemCode')
                          }
                        />
                      </div>
                      <div className='inputContainer2'>
                        <p className='label4'>
                          Quantity:
                          <span
                            style={errorChecker}
                            className='projectClassEmptyError'
                          >
                            *
                          </span>
                        </p>
                        <input
                          className='input4'
                          type='text'
                          id={index}
                          min='1'
                          name='quantity'
                          placeholder='Required'
                          autoComplete='off'
                          value={data.quantity}
                          onBlur={e =>
                            this.props.onBlurNumber(e, index, 'quantity')
                          }
                          onChange={event =>
                            this.props.changed(event, index, 'quantity')
                          }
                        />
                      </div>
                    </div>
                  ) : null}

                  {/* DESCRIPTION 1 */}
                  <p className='label2'>
                    Description 1
                    <span
                      style={errorChecker}
                      className='projectClassEmptyError'
                    >
                      *
                    </span>
                  </p>
                  <input
                    className='description1Class'
                    type='text'
                    name='description1'
                    id={index}
                    autoComplete='off'
                    placeholder='Required'
                    value={data.description1}
                    onChange={event =>
                      this.props.changed(event, index, 'description1')
                    }
                  />

                 {/* DESCRIPTION  2*/}
                 {this.props.isProject ? (
                    <>
                    {data.projectClass.includes('Subcon')
                    ? <>
                    <p className='label2'>
                        Charges to Subcon
                        <span
                          style={errorChecker}
                          className='projectClassEmptyError'
                        ></span>
                      </p>
                      <select
                        className='description2Class'
                        name='description2'
                        id={index}
                        autoComplete='off'
                        placeholder='Optional'
                        value={data.description2}
                        onChange={e =>
                          this.props.handleChangeProjectClassValue(
                            e,
                            index,
                            'description2'
                          )
                        }>
                          <option className='vendorListData' value=''>--Options--</option>
                      {this.props.vendorLists.map(data => (
                          <option className='vendorListData' value={data} >{data}</option>
                        ))}
                      </select></>
                      :
                      <>
                      <p className='label2'>
                        Description 2
                        <span
                          style={errorChecker}
                          className='projectClassEmptyError'
                        ></span>
                      </p>
                      <input
                        className='description2Class'
                        type='text'
                        name='description2'
                        id={index}
                        autoComplete='off'
                        placeholder='Optional'
                        value={data.description2}
                        onChange={e =>
                          this.props.handleChangeProjectClassValue(
                            e,
                            index,
                            'description2'
                          )
                        }
                      />
                      </>}


                    </>
                  ) : (
                    <>
                      <p className='label2'>
                        Description 2
                        <span
                          style={errorChecker}
                          className='projectClassEmptyError'
                        ></span>
                      </p>
                      <input
                        className='description2Class'
                        type='text'
                        name='description2'
                        id={index}
                        autoComplete='off'
                        placeholder='Optional'
                        value={data.description2}
                        onChange={e =>
                          this.props.handleChangeProjectClassValue(
                            e,
                            index,
                            'description2'
                          )
                        }
                      />
                    </>
                  )}

                  {/* Gross Price  */}
                  <p className='label2'>
                    Gross Price:
                    <span
                      style={errorChecker}
                      className='projectClassEmptyError'
                    >
                      *
                    </span>
                  </p>
                  <input
                    className='description2Class'
                    min='0.01'
                    step='any'
                    type='number'
                    name='grossPricePerItem'
                    id={index}
                    autoComplete='off'
                    placeholder='Required'
                    value={data.grossPricePerItem}
                    onBlur={e =>
                      this.props.onBlurNumber(e, index, 'grossPricePerItem')
                    }
                    onChange={event =>
                      this.props.changed(event, index, 'grossPricePerItem')
                    }
                  />

                  {/* VAT TYPE AND WITHHOLDING TAX */}
                  <div className='quantityAndItemNumber'>
                    <div className='inputContainer1'>
                      <p className='label3'>
                        Vat Type.:
                        <span
                          style={errorChecker}
                          className='projectClassEmptyError'
                        >
                          *
                        </span>
                      </p>
                      {/* <input className="input5" type="text"/> */}
                      <select
                        className='input5'
                        id={index}
                        type='number'
                        name='vatType'
                        placeholder='Required'
                        value={data.vatType}
                        onChange={event =>
                          this.props.changed(event, index, 'vatType')
                        }
                      >
                        <option
                          className='vatTypeInitialValue'
                          value=''
                          selected
                          hidden
                        >
                          Please Choose...
                        </option>
                        {this.props.vatTypeSelections}
                      </select>
                    </div>
                    <div className='inputContainer2'>
                      <p className='label3'>
                        Withholding Tax:
                        <span
                          style={errorChecker}
                          className='projectClassEmptyError'
                        >
                          *
                        </span>
                      </p>
                      {/* <input className="input6" type="text"/>/ */}
                      <select
                        className='input6'
                        id={index}
                        type='text'
                        name='wTaxType'
                        value={this.props.projectClass[index].wTaxType}
                        onChange={event =>
                          this.props.changed(event, index, 'wTaxType')
                        }
                      >
                        {this.props.wTaxRates.map(
                          ({ wTaxCode, wTaxDisplayName }) => {
                            return (
                              <option key={wTaxCode} value={wTaxCode}>
                                {wTaxCode === 'X1'
                                  ? 'None (X1)'
                                  : wTaxDisplayName + ' ' + wTaxCode}
                              </option>
                            )
                          }
                        )}
                      </select>
                    </div>
                  </div>
                  <div className='subComputationContainer'>
                    <div className='subComputation1'>
                      <p>Sub Total Gross Price</p>
                      <p>Sub Total Net Price</p>
                    </div>
                    <div className='subComputation2'>
                      <div className='subComputations'>
                        <span>
                          <h4 style={padding1}>&#8369;</h4>
                          <h4 className='subTotalGrossPrice'>
                            {data.subTotalGrossPrice % 1 === 0 &&
                            (data.subTotalGrossPrice % 1).length > 1
                              ? `${data.subTotalGrossPrice}.00`
                              : data.subTotalGrossPrice}
                          </h4>
                        </span>
                        <span>
                          <h4 style={padding1}>&#8369;</h4>
                          <h4 className='subTotalNetPrice'>
                            {data.subTotalNetPrice % 1 === 0 &&
                            (data.subTotalNetPrice % 1).length > 1
                              ? `${data.subTotalNetPrice}.00`
                              : data.subTotalNetPrice}
                          </h4>
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* COC EXPENSES LIST */}
                  <datalist id='cocExpenses'>
                    {this.props.cocExpenses.map(data => (
                      <option value={data} />
                    ))}
                  </datalist>
                  {/* ADVANCES LIST */}
                  <datalist id='advances'>
                    {this.props.advances.map(data => (
                      <option value={data} />
                    ))}
                  </datalist>
                  {/* PPE ACCOUNTS LIST */}
                  <datalist id='ppeAccounts'>
                    {this.props.ppeAccounts.map(data => (
                      <option value={data} />
                    ))}
                  </datalist>
                  {/* Admin Expenses */}
                  <datalist id='adminExpenses'>
                    {this.props.adminExpenses.map(data => (
                      <option value={data} />
                    ))}
                  </datalist>

                  {/* OPEX */}
                  <datalist id='opex'>
                    {this.props.opex.map(data => (
                      <option value={data} />
                    ))}
                  </datalist>

                  <datalist id='itemNumberList'>
                    {this.state.itemNoLists.map(data => (
                      <option value={data} />
                    ))}
                  </datalist>
                  {/*END OF GL CATEGORY NAME */}
                </div>
              ))}
              {/* ======================================================================================================== */}
              {/*END OF PAGE 2 */}
            </div>
            <div id='totalComputation' className='totalComputation'>
              <div className='computationDesc'>
                <h4>Requesting Gross Price:</h4>
                <h4>Requesting Amount:</h4>
              </div>
              <div className='computations'>
                <span>
                  <h4 style={padding1}>&#8369;</h4>
                  <h4 id='requestingGrossPrice'>
                    {this.props.requestingGrossPrice % 1 === 0 &&
                    (this.props.requestingGrossPrice % 1).length > 1
                      ? `${this.props.requestingGrossPrice}.00`
                      : this.props.requestingGrossPrice}
                  </h4>
                </span>
                <span>
                  <h4 style={padding1}>&#8369;</h4>
                  <h4 id='requestingAmount'>
                    {this.props.requestingAmount % 1 === 0 &&
                    (this.props.requestingAmount % 1).length > 1
                      ? `${this.props.requestingAmount}.00`
                      : this.props.requestingAmount}
                  </h4>
                </span>
              </div>
              <div className='addProjectClassBtnContainer'>
                <h5 onClick={this.props.addProjectClass}>Add Project Class</h5>
              </div>
            </div>

            <div className='formHintContainer' id='formHintContainer'>
              <i
                id='validationHintIcon'
                class='fas fa-exclamation-triangle'
              ></i>
              <span>
                Error:
                <span id='draftErrorHint'></span>
              </span>
              <span id='errorHint'></span>
            </div>

            <div id='submitButtonDiv' className='submitButtonDiv'>
              <button
                id='submitButton'
                type='submit'
                disabled={this.props.isLoading}
                style={this.props.isLoading ? { backgroundColor: 'grey' } : {}}
              >
                Submit
              </button>
            </div>
          </form>

          <div id='nextButton' className='nextButton'>
            <button type='button' onClick={this.handleShowPage2}>
              NEXT
            </button>
          </div>

          {/* <button onClick={this.props.checkStateValue}>Check State</button> */}
        </div>
      </>
    )
  }
}

const currentAttachPdf = {
  color: 'white',
  fontFamily: 'Calibri',
  fontSize: '15px',
  fontWeight: 'bold',
  background: '#ee3124',
  marginTop: '10px',
  padding: '5px',
  cursor: 'pointer'
}

const styleBtn = {
  background: '#2B2C2B',
  color: 'white',
  cursor: 'pointer'
}

const errorChecker = {
  color: 'red',
  fontFamily: 'Calibri',
  fontSize: '15px'
}
const padding1 = {
  paddingRight: '5px'
}

const displayNone = {
  display: 'none'
}

export default DraftView
